<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>
                    PAGAMENTOS
                    <slot name="titulo"></slot>
                </h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblPagamentos"
                    :itens="pagamentos"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <slot name="botoes"></slot>
                    </template>
                    <template slot="valorBruto" slot-scope="data">
                        {{ data.valorBruto | currency }}
                    </template>
                    <template slot="valorLiquido" slot-scope="data">
                        {{ data.valorLiquido | currency }}
                    </template>
                    <template slot="irrf" slot-scope="data">
                        {{ data.irrf | currency }}
                    </template>
                    <template slot="inss" slot-scope="data">
                        {{ data.inss | currency }}
                    </template>
                    <template slot="iss" slot-scope="data">
                        {{ data.iss | currency }}
                    </template>
                    <template slot="contribuicoes" slot-scope="data">
                        {{ data.contribuicoes | currency }}
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <slot name="acoes" v-bind="data"></slot>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
export default {
    components: {},

    props: {
        pagamentos: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'documento',
                    label: 'NF',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'dataEmissao',
                    label: 'Emissão',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataVencimento',
                    label: 'Vencimento',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'dataPagamento',
                    label: 'Pagamento',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'historico',
                    label: 'Histórico',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valorBruto',
                    label: 'Valor Bruto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'irrf',
                    label: 'IR Retido',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'inss',
                    label: 'INSS Retido',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'iss',
                    label: 'ISS Retido',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'contribuicoes',
                    label: 'Contribuições',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorLiquido',
                    label: 'Valor Líquido',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    tdClass: 'text-nowrap text-center',
                    type: 'status'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {},

    created() {},

    computed: {},

    watch: {}
}
</script>
